
import { random } from 'lodash-es'
import animate from '@/utils/animate'

export default {
  name: 'ModalStatus',

  props: {
    loadingText: { type: String, default: 'Waiting for transaction' },
    successText: { type: String, default: 'Transaction successful' },
    errorText: { type: String, default: 'oops, something went wrong' },
    call: { type: Function, default: () => {} },
  },

  data() {
    return {
      status: 'PENDING',
      successImgId: 1,
    }
  },

  methods: {
    async open() {
      const { status } = this.$refs;
      status.classList.remove('hidden');
      animate(status, {opacity: [0, 1]}, 200);
      document.addEventListener('keydown', this.escHandler, true);
      try {
        await this.call();
        this.showSuccessStatus();
      } catch (error) {
        console.error(error);
        this.showErrorStatus();
      }
    },

    showSuccessStatus() {
      const { succesImg } = this.$refs;
      this.status = 'SUCCESS';
      this.successImgId = random(1, 10);
      succesImg.classList.remove('hidden');
      animate(succesImg, {opacity: [0, 1]}, 50, 300);
      animate(succesImg, {translateY: [-100, 0]}, 50, 300);
      setTimeout(this.quit, 5000); // auto quit after 5s
    },

    showErrorStatus() {
      this.status = 'ERROR';
      setTimeout(this.quit, 5000); // auto quit after 5s
    },

    quit() {
      const { succesImg, status } = this.$refs;
      animate(status, {opacity: [1, 0]}, 400);
      animate(succesImg, {translateY: [0, -100]}, 300);
      setTimeout(() => this.$el.remove(), 500);
    },

    escHandler(event) {
      if (event.keyCode === 27) { // ESC key
        this.quit();
        event.preventDefault();
        event.stopPropagation();
        document.removeEventListener('keydown', this.escHandler, true)
      }
    },
  }

}
